import React, { useState } from "react";
import "./RestaurantOverview.css";
import {
  FaShieldAlt,
  FaCheckCircle,
  FaHatCowboy,
  FaUtensils,
  FaCouch,
  FaWineGlassAlt,
  FaClock,
  FaUserFriends,
  FaTshirt,
  FaCalendarCheck,
  FaMusic,
  FaHeart,
  FaFileDownload,
} from "react-icons/fa";

const getLabelIcon = (label) => {
  switch (label.toLowerCase()) {
    case "veg":
      return "🥗";
    case "non-veg":
      return "🍖";
    case "spicy":
      return "🌶️";
    case "signature":
      return "⭐";
    default:
      return "🍽️";
  }
};

const dishes = [
  {
    name: "Grilled Ribeye Steak",
    image: "https://images.unsplash.com/photo-1551183053-bf91a1d81141",
    description: "Chargrilled with garlic butter and herbs.",
    labels: ["Non-Veg", "Signature"],
  },
  {
    name: "Truffle Alfredo Pasta",
    image: "https://www.thefitpeach.com/wp-content/uploads/2023/07/Truffle-Pasta-The-Fit-Peach-10-1-scaled.jpg",
    description: "Rich creamy white sauce with truffle oil.",
    labels: ["Veg"],
  },
  {
    name: "Chocolate Lava Cake",
    image: "https://preview.redd.it/ae08bwkgh4h41.jpg?auto=webp&s=443392e45154dcc7598c05d0d42ae905a17099ca",
    description: "Molten center with vanilla ice cream.",
    labels: ["Veg", "Signature"],
  },
  {
    name: "Spicy Schezwan Noodles",
    image: "https://www.cookwithmanali.com/wp-content/uploads/2021/08/Schezwan-Noodles-310x310.jpg",
    description: "Hot and spicy Indo-Chinese noodles.",
    labels: ["Veg", "Spicy"],
  },
];



const items = [
  {
    title: "Food Safety Standards",
    icon: <FaShieldAlt />,
    content:
      "Our kitchen is FSSAI-certified and follows HACCP protocols to ensure top food safety standards.",
  },
  {
    title: "Daily Cleaning & Sanitization",
    icon: <FaCheckCircle />,
    content:
      "All dining areas, kitchen surfaces, and utensils are sanitized daily with WHO-approved methods.",
  },
  {
    title: "Experienced Chefs",
    icon: <FaHatCowboy />,
    content:
      "Our chefs have 10+ years of international culinary experience with certifications from top institutes.",
  },
];

const RestaurantOverview = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <>
      {/* HERO */}
      <div className="restaurant-overview">
        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1565299624946-b28f40a0ae38"
            alt="Elegant Restaurant Ambiance"
            loading="lazy"
          />
          <div className="hero-text">
            <h1>Our Restaurant</h1>
            <p>Elegant Dining. Diverse Flavors. Unforgettable Experiences.</p>
          </div>
        </div>

        <div className="overview-content container">
          <div className="overview-block">
            <FaWineGlassAlt className="icon" />
            <h3>Ambiance</h3>
            <p>
              Enjoy an elegant atmosphere with natural décor, warm lighting,
              and soft music. Perfect for families, couples, or corporate
              dinners.
            </p>
          </div>

          <div className="overview-block">
            <FaUtensils className="icon" />
            <h3>Cuisine</h3>
            <p>
              We offer a multi-cuisine experience including Indian, Italian,
              Chinese, and Fusion delicacies curated by top chefs.
            </p>
          </div>

          <div className="overview-block">
            <FaCouch className="icon" />
            <h3>Seating Styles</h3>
            <p>
              Choose from luxurious indoor seating, cozy garden-side tables, or
              private cabanas for a more intimate experience.
            </p>
          </div>
        </div>
      </div>

      {/* DINING ACCESS */}
<div className="dining-access">
      <div className="container">
        <div className="access-text">
  <h1>Dining Hours & Access</h1>
  <p className="intro">
    Whether you're planning a family brunch, a romantic dinner, or a business
    meal, our flexible hours and easy access make it seamless. Learn about our
    dining schedule, guest access policies, and attire guidelines to enjoy a
    truly elevated experience.
  </p>
</div>


        <div className="access-grid">
          <div className="access-card">
            <FaClock className="icon" />
            <h3>Opening Hours</h3>
            <p>
              Open daily from <strong>7:00 AM</strong> to{" "}
              <strong>11:00 PM</strong>.
            </p>
          </div>

          <div className="access-card">
            <FaUserFriends className="icon" />
            <h3>Guest Access</h3>
            <p>
              All resort guests welcome. Outside guests may reserve a table
              online or by phone.
            </p>
          </div>

          <div className="access-card">
            <FaTshirt className="icon" />
            <h3>Dress Code</h3>
            <p>
              <strong>Smart casual</strong> preferred. Kindly avoid swimwear or
              sportswear inside the dining area.
            </p>
          </div>

          <div className="access-card">
            <FaCalendarCheck className="icon" />
            <h3>Reservation Policy</h3>
            <p>
              Reservations are <strong>recommended after 7:00 PM</strong>,
              especially on weekends and holidays.
            </p>
          </div>
        </div>
      </div>
    </div>
      {/* MENU HIGHLIGHTS */}
      <div className="menu-highlights">
        <div className="container">
          <div className="menu-header">
            <h1> Menu Highlights</h1>
            <a
              href="/menu.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="download-button"
            >
              <FaFileDownload /> Download Full Menu
            </a>
          </div>
          <div className="dish-grid">
            {dishes.map((dish, index) => (
              <div className="dish-card" key={index}>
                <img
                  src={dish.image}
                  alt={`Dish: ${dish.name}`}
                  loading="lazy"
                  onError={(e) =>
                    (e.target.src = "https://via.placeholder.com/300x200")
                  }
                />
                <h3>{dish.name}</h3>
                <p>{dish.description}</p>
                <div className="labels">
                  {dish.labels.map((label, i) => (
                    <span className={`label ${label.toLowerCase()}`} key={i}>
                      {getLabelIcon(label)} {label}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      

      {/* HYGIENE & SAFETY */}
      <div className="hygiene-safety">
        <div className="container">
          <h1> Hygiene & Safety</h1>
          <div className="accordion">
            {items.map((item, index) => (
              <div
                className={`accordion-item ${
                  activeIndex === index ? "active" : ""
                }`}
                key={index}
                onClick={() =>
                  setActiveIndex(activeIndex === index ? null : index)
                }
                onKeyDown={(e) =>
                  e.key === "Enter" &&
                  setActiveIndex(activeIndex === index ? null : index)
                }
                tabIndex={0}
                role="button"
                aria-expanded={activeIndex === index}
              >
                <div className="accordion-title">
                  <span className="icon">{item.icon}</span>
                  {item.title}
                </div>
                {activeIndex === index && (
                  <div className="accordion-content">
                    <p>{item.content}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default RestaurantOverview;
